import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdAcaoQualidade: number;
  tipoPesquisa: number,
  status: number,
  pesquisa: string | Date | number | null,
  centroDeCusto: number[],
  centroDeCustoLista: CentroCustoDropDown[] | undefined,

};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setTipoPesquisa: SetFunction<number>,
  setStatus: SetFunction<number>,
  setPesquisa: SetFunction<string | Date | number | null>,
  setCentroDeCusto: SetFunction<number[]>,
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>,
};


export const initialFiltersValues: State = {
  IdAcaoQualidade: 0,
  tipoPesquisa: 0,
  pesquisa: "",
  status: 0,
  centroDeCusto: [],
  centroDeCustoLista: undefined,
};

export const useAcoesMelhoriasFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setStatus: (vfn) => SetFunctionImpl(set, 'status', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  clearFilters: () => set(initialFiltersValues),

}));